import _ from 'lodash';
import { createContext, useCallback, useContext, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { resolveNavAction } from './resolveNavAction';
const BatchedNavActionContext = createContext(null);
export function BatchedNavActionProvider({
  children
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const batch = useRef(null);
  const dispatchNavAction = useCallback(navAction => {
    if (batch.current === null) {
      batch.current = [];
      setTimeout(() => {
        if (batch.current === null) {
          throw new Error('Flush batch ran when batch was null. This should be impossible.');
        }
        const {
          to,
          state,
          replace
        } = resolveNavAction(location, ...batch.current);
        const currPath = _.pick(location, ['pathname', 'search', 'hash']);
        const isNewPath = _.isEqual(currPath, to);
        const hasState = state ? _.isObject(state) ? !_.isEmpty(state) : true : false;
        if (!isNewPath || hasState) {
          void navigate(to, {
            state,
            replace
          });
        }
        batch.current = null;
      }, 0);
    }
    batch.current.push(navAction);
  }, [location, navigate]);
  return <BatchedNavActionContext.Provider value={dispatchNavAction}>
			{children}
		</BatchedNavActionContext.Provider>;
}

/**
 * Use {@link LinkNavAction} instead of this where possible.
 *
 * Changes the current location when called. For example, this can be used to
 * redirect after a form submission.
 *
 * @see {@link NavAction}'s doc comment for example usage.
 */
export function useDispatchNavAction() {
  const dispatchNavAction = useContext(BatchedNavActionContext);
  if (!dispatchNavAction) {
    throw new Error('useDispatchNavAction must be used within a BatchedNavActionProvider');
  }
  return dispatchNavAction;
}